<template>
  <td
    colspan="13"
    class="pa-0"
  >
    <v-simple-table v-if="article.article_table === 'smartphone_extras'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Data Acquisto</th>
            <th class="primary--text">Fornitore</th>
            <th class="primary--text">Costo</th>
            <th class="primary--text">EAN</th>
            <th class="primary--text">IMEI</th>
            <th class="primary--text">Brand</th>
            <th class="primary--text">Modello</th>
            <th class="primary--text">Colore</th>
            <th class="primary--text">HDD</th>
            <th class="primary--text">RAM</th>
            <th class="primary--text">Grado</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ posixToItalianDate(article.article[0].posix) }}</td>
            <td>{{ article.supplier[0].name }}</td>
            <td>{{ article.article[0].cost }}€</td>
            <td>{{ article.article[0].ean }}</td>
            <td>{{ article.article[0].serial_number }}</td>
            <td>{{ article.article[0].brand }}</td>
            <td>{{ article.article[0].model }}</td>
            <td>{{ article.article[0].color }}</td>
            <td>{{ article.article[0].disk_space }}</td>
            <td>{{ article.article[0].ram }}</td>
            <td>{{ article.article[0].grade }}</td>
            <td class="actions">
              <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso </v-btn>
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.article_table === 'accessory_extras'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Data Acquisto</th>
            <th class="primary--text">Fornitore</th>
            <th class="primary--text">Brand</th>
            <th class="primary--text">Prodotto</th>
            <th class="primary--text">Colore</th>
            <th class="primary--text">Modello</th>
            <th class="primary--text">Costo</th>
            <th class="primary--text">EAN</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ posixToItalianDate(article.article[0].posix) }}</td>
            <td>{{ article.supplier[0].name }}</td>
            <td>{{ article.article[0].brand }}</td>
            <td>{{ article.article[0].model }}</td>
            <td>{{ article.article[0].color }}</td>
            <td>{{ article.article[0].desctiption }}</td>
            <td>{{ article.article[0].cost }}€</td>
            <td>{{ article.article[0].serial_code }}</td>
            <td class="actions">
              <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso </v-btn>
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.article_table === 'services' || article.article_table === 'lessons'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Nome</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ article.article[0].name }}</td>
            <td class="actions">
              <!-- <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso
              </v-btn> -->
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.article_table === 'repairs'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Brand</th>
            <th class="primary--text">Modello</th>
            <th class="primary--text">Colore</th>
            <th class="primary--text">IMEI</th>
            <th class="primary--text">Cliente</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ article.article[0].brand }}</td>
            <td>{{ article.article[0].model }}</td>
            <td>{{ article.article[0].color }}</td>
            <td>{{ article.article[0].serial }}</td>
            <td>{{ article.article[0].name }} {{ article.article[0].surename }}</td>
            <td class="actions">
              <!-- <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso
              </v-btn> -->
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.kind === 'Attivazione SIM'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Data Acquisto</th>
            <th class="primary--text">Seriale</th>
            <th class="primary--text">Operatore</th>
            <th class="primary--text">Offerta</th>
            <th class="primary--text">Tipologia</th>
            <th class="primary--text">Pagamento</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ posixToItalianDate(article.article[0].posix) }}</td>
            <td>{{ article.article[0].serial_number }}</td>
            <td>{{ article.operator_to }}</td>
            <td>{{ article.offer_name }}</td>
            <td>{{ article.contract_kind }}</td>
            <td>{{ article.offer_payment }}</td>
            <td class="actions">
              <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso </v-btn>
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.kind === 'Portabilità SIM'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Data Acquisto</th>
            <th class="primary--text">Seriale</th>
            <th class="primary--text">Operatore</th>
            <th class="primary--text">Provenienza</th>
            <th class="primary--text">Offerta</th>
            <th class="primary--text">Tipologia</th>
            <th class="primary--text">Pagamento</th>
            <th class="primary--text">Triangolazione</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ posixToItalianDate(article.article[0].posix) }}</td>
            <td>{{ article.article[0].serial_number }}</td>
            <td>{{ article.operator_to }}</td>
            <td>{{ article.operator_from }}</td>
            <td>{{ article.offer_name }}</td>
            <td>{{ article.contract_kind }}</td>
            <td>{{ article.offer_payment }}</td>
            <td>
              <span v-if="article.dumping">
                <v-icon color="green">mdi-check</v-icon>
              </span>
              <span v-else>
                <v-icon color="red">mdi-close</v-icon>
              </span>
            </td>
            <td class="actions">
              <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso </v-btn>
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.kind === 'Attivazione Fisso'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Operatore</th>
            <th class="primary--text">Offerta</th>
            <th class="primary--text">Tipologia</th>
            <th class="primary--text">Pagamento</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ article.operator_to }}</td>
            <td>{{ article.offer_name }}</td>
            <td>{{ article.contract_kind }}</td>
            <td>{{ article.offer_payment }}</td>
            <td class="actions">
              <!-- <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso
              </v-btn> -->
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.kind === 'Portabilità Fisso'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Operatore</th>
            <th class="primary--text">Provenienza</th>
            <th class="primary--text">Offerta</th>
            <th class="primary--text">Tipologia</th>
            <th class="primary--text">Pagamento</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ article.operator_to }}</td>
            <td>{{ article.operator_from }}</td>
            <td>{{ article.offer_name }}</td>
            <td>{{ article.contract_kind }}</td>
            <td>{{ article.offer_payment }}</td>
            <td class="actions">
              <!-- <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso
              </v-btn> -->
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table v-else-if="article.kind === 'Ricarica Telefonica'">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="primary--text">Operatore</th>
            <th class="primary--text"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ article.operator_from }}</td>
            <td class="actions">
              <!-- <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click="clickHandler(true)"
              >Reso
              </v-btn> -->
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click="clickHandler(false)"
              >Elimina </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- dialog -->

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">{{ dialogData.title }}</v-card-title>

          <v-card-text>
            {{ dialogData.message }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="dialogData.isReso ? reso() : elimina()"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </td>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ArticleDetails',
    props: {
      article: { type: Object, default: () => { } },
    },
    data() {
      return {
        dialog: false,
        dialogData: {
          isReso: false,
          title: '',
          message: '',
        },
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    methods: {
      clickHandler(isReso) {
        if (isReso) {
          this.dialogData = {
            isReso,
            title: 'Confermi il reso?',
            message:
              "Confermando, il prodotto selezionato verrà riaggiunto al magazzino e l'operazione registrata come reso.",
          }
        } else {
          this.dialogData = {
            isReso,
            title: "Eliminare l'operazione?",
            message:
              "Confermando, l'operazione di vendita selezionata verrà eliminata definitivamente e il prodotto  riaggiunto al magazzino.",
          }
        }

        this.dialog = true
      },
      async reso() {
        const { data } = await axios.post(`${process.env.VUE_APP_API}/operations/reso`, this.article, this.config)

        if (data.status) {
          this.$emit('fetch')
          this.dialog = false
        } else {
          alert('Si è verificato un errore.')
        }
      },
      async elimina() {
        const { data } = await axios.post(`${process.env.VUE_APP_API}/operations/delete`, this.article, this.config)

        if (data.status) {
          this.$emit('fetch')
          this.dialog = false
        } else {
          alert('Si è verificato un errore.')
        }
      },
      posixToItalianDate(posix) {
        return new Date(posix).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
      },
    },

    mounted() {
      //console.log(this.article)
    },
  }
</script>

<style>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>
